export const MAIN_SLUG_FIELD_KEY = '_slug'

export const MAIN_SLUG_PATTERN = `/{${MAIN_SLUG_FIELD_KEY}}`

export const MAIN_SLUG_FIELD_DISPLAY_NAME = 'Slug item'
